import * as React from "react";
const SvgFiBrandsJanseen = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 25 24"
    {...props}
  >
    <path
      fill="#151A2D"
      d="M12.46 11.631c0 5.54-2.515 9.621-5.766 12.37 5.49-1.108 9.69-6.936 9.69-13.208a25 25 0 0 0-.026-1.48l4.243-1.393c.537-.18.88-.46.881-.953l.003-.505c-2.293-.04-10.609-.304-10.609-.304.78 1.177 1.583 3.197 1.583 5.473M10.552 4.74c3.892.566 6.308.122 6.308.122s-.555-1.965-2.163-1.972c-2.548-.01-4.343-.258-4.343-.258C4.922 1.843 3.514 0 3.514 0c.317 2.031 3.562 4.232 7.038 4.74"
    />
  </svg>
);
export default SvgFiBrandsJanseen;
